const WeightRestrictionType = {
  ALL_WEIGHTS: "all-weights",
  WEIGHT_RANGE: "weight-range",
} as const;

type WeightRestrictionType =
  typeof WeightRestrictionType[keyof typeof WeightRestrictionType];

export default WeightRestrictionType;
